'use client';

import { createMedia } from '@artsy/fresnel';
import type { ReactNode } from 'react';

const MediaQuery = createMedia({
  breakpoints: {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600,
  },
});

const Media = MediaQuery.Media;
const MediaContextProvider = MediaQuery.MediaContextProvider;
const mediaStyles = MediaQuery.createMediaStyle();

type MediaWrapperProps = Readonly<{
  children: ReactNode;
}>;

const MobileMedia = ({ children }: MediaWrapperProps) => <Media lessThan="md">{children}</Media>;

const LargeTabletMedia = ({ children }: MediaWrapperProps) => <Media lessThan="lg">{children}</Media>;

const TabletMedia = ({ children }: MediaWrapperProps) => <Media greaterThanOrEqual="lg">{children}</Media>;

const DesktopMedia = ({ children }: MediaWrapperProps) => <Media greaterThanOrEqual="xl">{children}</Media>;

const TabletDesktopMedia = ({ children }: MediaWrapperProps) => <Media greaterThanOrEqual="md">{children}</Media>;

export {
  DesktopMedia,
  LargeTabletMedia,
  Media,
  MediaContextProvider,
  MobileMedia,
  mediaStyles,
  TabletDesktopMedia,
  TabletMedia,
};
